import { render, staticRenderFns } from "./labAssignmentsInfoWidget.vue?vue&type=template&id=7beae1a9&scoped=true"
import script from "./labAssignmentsInfoWidget.vue?vue&type=script&lang=js"
export * from "./labAssignmentsInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./labAssignmentsInfoWidget.vue?vue&type=style&index=0&id=7beae1a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beae1a9",
  null
  
)

export default component.exports